import { render } from "./BusGuideSheet.vue?vue&type=template&id=867a6a88&scoped=true"
import script from "./BusGuideSheet.vue?vue&type=script&lang=js"
export * from "./BusGuideSheet.vue?vue&type=script&lang=js"

import "./BusGuideSheet.vue?vue&type=style&index=0&id=867a6a88&scoped=true&lang=css"
import "./BusGuideSheet.vue?vue&type=style&index=1&id=867a6a88&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-867a6a88"]])

export default __exports__